
import { Document, Page, Text, View, StyleSheet, Font, Image } from '@react-pdf/renderer';
import moment from 'moment';

const Invoice2PDF = ({ data, amount, classList }) => {
    const pname = data.fullname;
    const date = new Date();
    const newDate = new Date(date.setMonth(date.getMonth() + 1));

    let totalAmount = 0;
    for (let i = 0; i < data.children.length; i++) {
        totalAmount += Math.round(data.children[i].amount)
    }
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', top: 0 }} />
                <Image source={require('../../images/gradient.png')} style={{ height: 20, width: "150%", position: 'absolute', bottom: 0 }} />
                <View style={{ height: 150 }}>
                    {/* <View style={{ alignItems: 'center', backgroundColor: "#FFA500", marginVertical: 10 }}>
                        <Text style={{ color: "white" }}>INVOICE</Text>
                    </View> */}
                    <Text style={{ fontSize: 16, fontFamily: 'Times-Bold', color: "#E56717", marginTop: 30 }}>INVOICE</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>PUSAT TUISYEN GENIUS MILENIA</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>17-1 , JALAN PANTAI MURNI 6, OFF, JALAN PANTAI DALAM, PANTAI DALAM</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>019-778 3518</Text>
                    <Image source={require('../../images/PTGM-Logo.png')} style={{ height: 100, width: 130, position: 'absolute', right: 30, top: 35 }} />
                </View>
                <View style={{ flexDirection: "row" }}>
                    <View style={{ flex: 2 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>ENCIK/PUAN,</Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>{pname ? pname.toUpperCase() : null}</Text>
                        {/* <Text style={{ fontSize: 11, fontFamily: 'Helvetica', marginTop: 50 }}>{sname ? "PELAJAR: " + sname.toUpperCase() : null}</Text> */}
                        {/* {muslim && <Image source={require('./image/assalam.png')} style={{ height: 30, width: 150, marginTop: 20 }} />} */}
                    </View>
                    <View style={{ flex: 1, borderWidth: 1, padding: 5 }}>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica', marginBottom: 10 }}>Submitted on 23-{moment(new Date()).format('MM-yyyy')}</Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>Invoice no.</Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica', marginBottom: 10 }}>REF: PTGM/AL/TM/PD03 <Text style={{ fontSize: 11, fontFamily: 'Helvetica', color: "red" }}>UNPAID</Text></Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>Due Date</Text>
                        <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>{"07-" + moment(newDate).format('MM-yyyy')}</Text>
                    </View>
                </View>
                <View style={{ margin: 20, borderWidth: 1, flexDirection: "row" }}>
                    {/* No */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 1, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>No</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>{index + 1}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Details */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 6, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Details</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} numberOfLines={1} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>Yuran Bulanan {moment(newDate).format('MMMM')} ({classList.find(val => val.batchId === value.class).batchName})</Text>
                            ))
                        }
                        {/* <Text style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>Yuran Bulanan {moment(newDate).format('MMMM')}</Text> */}
                        {/* <Text style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3, paddingBottom: 150 }}>{detail}</Text> */}
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Total Amount</Text>
                        </View>
                    </View>
                    {/* Quantity */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Quantity</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>1</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Unit Price */}
                    <View style={{ borderRightWidth: 1, alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Unit Price</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>RM{value.amount}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3, color: "white" }}>0</Text>
                        </View>
                    </View>
                    {/* Amount (RM) */}
                    <View style={{ alignItems: 'center', flex: 2, height: 180 }}>
                        <View style={{ borderBottomWidth: 1, width: "100%", alignItems: "center" }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>Amount (RM)</Text>
                        </View>
                        {
                            data.children.map((value, index) => (
                                <Text key={index} style={{ fontSize: 11, fontFamily: 'Helvetica', margin: 3 }}>RM{value.amount}</Text>
                            ))
                        }
                        <View style={{ borderTopWidth: 1, width: "100%", alignItems: "center", position: "absolute", bottom: 0 }}>
                            <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', margin: 3 }}>RM{totalAmount}</Text>
                        </View>
                    </View>
                </View>
                <View>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>Pilihan cara bayaran:</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>1. Bayaran terus kepada admin di pusat tuisyen</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>2. Bayaran secara online ke akaun bank (BANK ISLAM) berikut;</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', marginLeft: 20 }}>Pusat Tuisyen Genius Milenia</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold', marginLeft: 20 }}>14238010014491</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica' }}>3. Whatsapp bukti bayaran kepada admin untuk kami kemaskini rekod pembayaran dan keluarkan resit.</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Helvetica', marginTop: 10 }}>Thank you.</Text>
                    <Text style={{ marginVertical: 10, padding: 10, backgroundColor: "red", color: "white", alignSelf: "flex-start", fontSize: 11, fontFamily: 'Helvetica' }}>DUE DATE {"07-" + moment(newDate).format('MM-yyyy')}</Text>
                    <Text style={{ fontSize: 11, fontFamily: 'Times-Italic' }}>‘Excellent Learning Experience’</Text>
                </View>
            </Page>
        </Document>

    )
};

export default Invoice2PDF;

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600, fontStyle: "italic" }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        padding: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
});